export default "__VITE_ASSET__Bo_gPpDO__"